// extracted by mini-css-extract-plugin
module.exports = {"entryButton":"EntryButton_entryButton__2GRvH"};